<template>
    <div :class="{'fans-page': true, 'iphone-x': isIPhoneX}">
        <transparent-header titleColor="#1A1A1A" color="#fff" :customOpacity="1"/>
        
        <template v-if="loadComplete && data">
            <div class="header">
                <van-notice-bar left-icon="volume-o" :scrollable="false" text="粉丝重新下一笔支付金额≥1元的订单即可激活" />
            </div>
            
            <div class="section">
                <div class="module-wrap clearfix">
                    <div class="module-con">
                        <van-list v-model="tab.loading" :finished="tab.finished" error-text="请求失败，点击重新加载" @load="getList(tab)">
                            <ul class="fan-list clearfix">
                                <li class="fan-item" v-for="(item, index) in tab.dataItems" :key="index">
                                    <div class="fan-pic">
                                        <van-image lazy-load :src="item.uPic">
                                            <template v-slot:loading>
                                                <van-loading type="spinner" size="20"/>
                                            </template>
                                        </van-image>
                                    </div>

                                    <div class="fan-con">
                                        <div class="fan-info">
                                            <div class="fan-nic-con"><div class="fan-nic">{{item.uNic}}</div><span class="fan-status">{{getMapProp(fansStateMap, item.fansState, "text")}}</span></div>

                                            <div class="register-time">注册时间：{{item.uCtimeStr}}</div>
                                        </div>

                                        <div class="fan-bar">
                                            <div class="invite-btn" @click="toInvite(item)">去邀请出单</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <template slot="finished">
                                <div class="no-data-wrap" v-if="!tab.dataItems.length">
                                    <div class="no-data">暂无数据</div>
                                </div>

                                <div class="van-list__finished-text" v-else>亲，到底了哦~</div>
                            </template>
                        </van-list>
                    </div>
                </div>
            </div>
    
            <!-- 置顶 -->
            <scroll-top/>
        </template>
        
        <loading ref="$loading"/>
    </div>
</template>

<script>
    import Vue from "vue";
    import {Toast, NoticeBar} from "vant";

    import commonMixin from "./mixins";   //用户的信息/loading共用mixin

    import {getFansList} from "@/views/activity2022/api/202205/promotion";

    Vue.use(NoticeBar);

    let pagination = {
        page: 1,
        pageSize: 30
    };

    let obj = {
        pagination,
        isLoad: false,
        loading: false,
        finished: false,
        error: false,
        loadComplete: false
    };

    let tab = {
        text: "粉丝列表",
        key: "fan",
        dataItems: [],
        ...obj
    };

    let background;
    let errorTip = "服务器繁忙，请稍后重试！";

    export default {
        mixins: [commonMixin],
        data() {
            return {
                loadComplete: false, //页面加载完成
                tab: JSON.parse(JSON.stringify(tab)),
                bg: "#F5F5F5", //背景色
                data: {}
            };
        },
        computed: {
            //活动唯一code
            id() {
                let code = "";
                let query = this.$route.query;

                if(query.id) {
                    code = query.id;
                }

                return code;
            }
        },
        watch: {},
        components: {},
        created() {
            background = document.body.style.background;
            
            this.setPageSettings();
        },
        mounted() {
            this.getList(this.tab, true);
        },
        beforeDestroy() {
            this.clearAny();
        },
        methods: {
            //销毁任何
            clearAny() {
                document.body.style.background = background;
            },
            //埋点
            trackEvent(key = "可激活直属粉丝页浏览量") {
                this.$uweb.trackEvent("activity2022", `5月QX_activity_${this.id}_${key}`, this.currentPlatform);
            },
            //获取列表
            getList(moduleData, showLoading = false) {
                return new Promise((resolve, reject) => {
                    let pagination = moduleData.pagination;

                    if(moduleData.isLoad) {
                        reject();

                        return;
                    }

                    let params = {
                        ...pagination,
                        pageNum: pagination.page,
                        activityId: this.id,
                        userId: this.userInfo.uid || this.$route.query.share_uid,
                        userType: this.userInfo.utype || this.$route.query.share_utype,
                        isSearchCount: false,
                        fansType: 2, //粉丝类型:1-有效直属粉丝，2-可激活直属粉丝，3-无效直属粉丝
                        showErrorToast: false
                    };

                    if(moduleData.error || moduleData.finished) {
                        moduleData.loading = false;
                        reject();

                        return;
                    }

                    moduleData.isLoad = true;

                    if(showLoading) {
                        this.showLoading();
                    }

                    getFansList(params).then((res) => {
                        let body = res.data || {};
                        let data = body.data || {};

                        let dataItems = data.list  || [];

                        if(showLoading) {
                            this.hideLoading();
                        }

                        if(body.code === 200) {
                            if(params.page == 1) {
                                moduleData.dataItems = dataItems;

                                this.loadComplete = true;

                                this.trackEvent();
                            } else {
                                moduleData.dataItems = moduleData.dataItems.concat(dataItems);
                            }

                            moduleData.pagination = {
                                ...pagination,
                                page: pagination.page + 1
                            };

                            if(dataItems && dataItems.length < pagination.pageSize) {
                                moduleData.finished = true;
                            }

                            moduleData.isLoad = false;
                            moduleData.loadComplete = true;

                            resolve();
                        } else {
                            Toast.clear();
                            this.$toast(body.message || errorTip);

                            moduleData.error = true;
                            moduleData.isLoad = false;
                            moduleData.loadComplete = true;

                            reject();
                        }
                    }, (res) => {
                        if(showLoading) {
                            this.hideLoading();
                        }

                        Toast.clear();
                        this.$toast(res.message || errorTip);

                        moduleData.error = true;
                        moduleData.isLoad = false;

                        reject();
                    }).catch(() => {
                        Toast.clear();

                        moduleData.error = true;
                        moduleData.isLoad = false;

                        reject();
                    }).finally(() => {
                        moduleData.loading = false;
                        moduleData.isLoad = false;

                        if(!moduleData.loadComplete) {
                            moduleData.loadComplete = true;
                        }
                    });
                }).catch(() => {});
            },
            //设置颜色
            setPageSettings() {
                document.body.style.background = this.bg;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@/views/activity2022/assets/less/pages/202205/promotion/fans-page.less";
</style>
